import React, { useState, useEffect } from "react";
import { Card, Row, Col } from "react-bootstrap";

function Transaction() {
  const [chrome, setChrome] = useState(true);

  useEffect(() => {
    let isChrome =
      /Chrome/.test(navigator.userAgent) &&
      !/Edg/.test(navigator.userAgent) &&
      /Google Inc/.test(navigator.vendor);
    setChrome(true);
  }, []);

  return (
    <>
      <div className="content">
        <Row>
          <Col xs={12}>
            <Card>
              <Card.Header>
                <Card.Title as="h4">Chrome browser</Card.Title>
              </Card.Header>
              <Card.Body className="text-center">
                {chrome && (
                  <i
                    className="fa fa-check-circle "
                    style={{ color: "green", fontSize: "100px" }}
                  ></i>
                )}
                {!chrome && (
                  <React.Fragment>
                    <i
                      className="fa fa-times-circle "
                      style={{ color: "red", fontSize: "100px" }}
                    ></i>
                    <br />
                    <em>
                      *Please open chrome browser for practice question(s)
                    </em>
                  </React.Fragment>
                )}
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </div>
    </>
  );
}

export default Transaction;
